exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.move * {\r\n  cursor: move !important;\n}\n.col-resizing * {\r\n  cursor: col-resize !important;\n}\r\n", ""]);

// exports
